module.exports = __webpack_public_path__ + "img/ucv.74053e82.gif";